"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((item, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="font-mono text-sm text-muted-foreground hover:text-primary transition-colors uppercase tracking-wide w-fit" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 lg:px-20 border-t border-border/10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">Vintage Portraits is an old-style photographic entertainment experience brought back to life by Italian Minuteros. It captures the magic of analog photography through handcrafted cameras and traditional film development.</p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium text-foreground">Explore</h3>
            <MenuProvider menu_id="36" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium text-foreground">Contact</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 text-muted-foreground group">
                <MapPin className="w-5 h-5 mt-0.5 shrink-0 group-hover:text-primary transition-colors" />
                <span className="text-sm font-mono">Str. San Marco, 81/c<br />06131 Perugia, Italia</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground group">
                <Phone className="w-5 h-5 shrink-0 group-hover:text-primary transition-colors" />
                <span className="text-sm font-mono">+39 393 9309343</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground group">
                <Mail className="w-5 h-5 shrink-0 group-hover:text-primary transition-colors" />
                <span className="text-sm font-mono">info@vignarolistudio.it</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-lg font-medium text-foreground">Social</h3>
            <div className="flex flex-col gap-3">
              <Link to="https://www.instagram.com/italian_minuteros/" newTab className="font-mono text-sm text-muted-foreground hover:text-primary transition-colors uppercase tracking-wide w-fit">INSTAGRAM</Link>
              <Link to="https://facebook.com" newTab className="font-mono text-sm text-muted-foreground hover:text-primary transition-colors uppercase tracking-wide w-fit">
                FACEBOOK
              </Link>
              <Link to="https://pinterest.com" newTab className="font-mono text-sm text-muted-foreground hover:text-primary transition-colors uppercase tracking-wide w-fit">
                PINTEREST
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-xs text-muted-foreground font-mono">© 2026 Italian Minuteros. All rights reserved.</p>
          
          <p className="text-sm font-serif italic text-foreground/80">Handcrafted with Light</p>

          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-xs text-muted-foreground hover:text-primary font-mono transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-primary font-mono transition-colors">
              Termini
            </Link>
          </div>
        </div>
      </div>
    </section>;
}